import { render, staticRenderFns } from "./StateBadge.vue?vue&type=template&id=eddaa2aa&"
import script from "./StateBadge.vue?vue&type=script&lang=js&"
export * from "./StateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports